import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { NavMenu } from './NavMenu';
import './css/NavMenu.css';

import SideBar from './SideBar';
import "react-pro-sidebar/dist/css/styles.css";
import './css/SideBar.css';

const ColoredLine = ({ color }) => (
  <hr
    style={{
      color: "#ffdb00",
      backgroundColor: "#ffdb00",
      height: 0.5
    }}
  />
);

const styles = {
    contentDiv: {
        display: "flex",
    },
    contentMargin: {
        marginLeft: "10px",
        width: "100%",
    },
};

export class Layout extends Component {
  static displayName = Layout.name;
  render() {
    return (
      <div className='wrapper' >
        {/*<NavMenu />*/}

        {/*<Container fluid>*/}
        {/*  <Row>*/}
        {/*    <Col className="">*/}
        {/*       <SideBar />*/}
        {/*    </Col>*/}
        {/*    <Col id="children">*/}
        {/*      {this.props.children}*/}
        {/*    </Col>*/}
        {/*  </Row>*/}
        {/*</Container>*/}
        {/*<ColoredLine color="#010453" />*/}
        {/*<Container fluid>*/}
        {/*  <p style={{*/}
        {/*    color: "#A9A9A9",*/}
        {/*    textAlign: "center",*/}
        {/*    fontSize: '0.65em',*/}
        {/*  }}>*/}
        {/*    Escuela Superior Polit&eacute;cnica del Litoral - Campus Gustavo Galindo - Guayaquil - Ecuador*/}
        {/*    <br />*/}
        {/*    &#169; El contenido de esta obra es de propiedad de la ESPOL. Todos los derechos reservados.*/}
        {/*    <br />*/}
        {/*    Prohibida su reproducci&oacute;n total o parcial, comunicaci&oacute;n p&uacute;blica o distribuci&oacute;n sin autorizaci&oacute;n previa del titular de los derechos.*/}
        {/*  </p>*/}
            {/*</Container>*/}

            <Row>
                <Col>
                    <NavMenu />
                </Col>
            </Row>
            <div style={styles.contentDiv}>
                <SideBar />
                <div style={styles.contentMargin}>
                    <div style={{ paddingLeft: "12vw", paddingRight: "5vw", minHeight: '72vh' }}>
                        {this.props.children}
                    </div>
                </div>
            </div>

            {/*<Container fluid>*/}
            {/*    <Card>*/}
            {/*        {this.props.children}*/}
            {/*    </Card>*/}
            {/*</Container>*/}
            {/*<Container fluid>*/}
            <p style={{ 
                    color: "#A9A9A9",
                    textAlign: "center",
                    fontSize: '0.65em',
                  }}>
                Escuela Superior Polit&eacute;cnica del Litoral - Campus Gustavo Galindo - Guayaquil - Ecuador
                <br />
                &#169; El contenido de esta obra es de propiedad de la ESPOL. Todos los derechos reservados.
                <br />
                Prohibida su reproducci&oacute;n total o parcial, comunicaci&oacute;n p&uacute;blica o distribuci&oacute;n sin autorizaci&oacute;n previa del titular de los derechos.
            </p>
            {/*</Container>*/}
        </div>
    );
  }
}
